import { IPlayingAgeViewModel } from "./PlayingAgeViewModel";
import { IDisabilitiesViewModel } from "./DisabilitiesViewModel";
import { IMembershipsViewModel } from "./MembershipsViewModel";
import { ILocationsViewModel } from "./LocationsViewModel";
import { ILocationViewModel } from "./LocationViewModel";
import { INationalityViewModel } from "./NationalityViewModel";
import { IPregnancyViewModel } from "./PregnancyViewModel";
import { IVocalViewModel } from "./VocalViewModel";
import { IDancingViewModel } from "./DancingViewModel";
import { IAppearanceViewModel } from "./AppearanceViewModel";
import { ITwinViewModel } from "./TwinViewModel";
import { IHeightViewModel } from "./HeightViewModel";
import { IGenderViewModel } from "shared/modules/BasicInfo/models/views/GenderViewModel";
import { FacetViewModel } from "shared/modules/BasicInfo/models/views/index";
import { IMakeupViewModel } from "./MakeupViewModel";
import { IHeritageAndEthnicityModel } from "component-library/src/components/Organisms/HeritageAndEthnicityList/HeritageAndEthnicityList";

export class BasicInfoViewModel
  implements
    IPlayingAgeViewModel,
    IHeightViewModel,
    IDisabilitiesViewModel,
    IGenderViewModel,
    IMembershipsViewModel,
    ILocationsViewModel,
    INationalityViewModel,
    IPregnancyViewModel,
    IVocalViewModel,
    IDancingViewModel,
    IAppearanceViewModel,
    IVocalViewModel,
    ITwinViewModel,
    IMakeupViewModel,
    IHeritageAndEthnicityModel
{
  fromAge: number;
  toAge: number;
  isActualAgeVisible: boolean;
  locations: ILocationViewModel[] = [];
  memberships: { id: number; name: string }[] = [];
  nationalities: { id: number; name: string }[] = [];
  height?: number;
  isPregnant: boolean;
  untilPregnantDate?: string | null;

  appearances: { id: number; name: string }[] = [];
  eyeColor?: number;
  hairColor?: number;
  hairLength?: number;
  facialHair?: number;
  voiceQuality?: number;
  voiceCharacter?: number;
  voiceStyle: { id: number; name: string }[];
  vocalAgeFrom?: number | null;
  vocalAgeTo?: number | null;
  lowerNote?: number;
  upperNote?: number;
  beltNote?: number;
  chestSize?: number;
  waistSize?: number;
  hipsSize?: number;
  insideLegSize?: number;
  insideArmSize?: number;
  collarSize?: number;
  hatSize?: number;
  shoeSize?: number;
  dressSize?: number;
  weight?: number;
  haveTwin: boolean;
  hasDisability: boolean;
  isVisibleDisability: boolean;
  disabilities: FacetViewModel[] = [];
  disabilityInfo: string;
  genders: FacetViewModel[] = [];
  disabilitiesInfo: string;
  isVisibleGender: boolean;
  genderInfo: string;
  heritageAndEthnicityInfo?: string;
  isVisibleHeritageAndEthnicity?: boolean;
  heritageAndEthnicity: { id: number; name: string }[];
  ethnicBackground: { id: number; name: string }[];
  visasAndPermits: { id: number; name: string }[];
  isVisibleVisasAndPermits?: boolean;
  makeUp?: string;
}
